import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IPatchOperation } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";
import { Task } from "fhir/r5";

/**
 * Atualiza uma tarefa existente com operações de patch dinâmicas
 * @param taskId ID da tarefa a ser atualizada
 * @param operations Lista de operações a serem aplicadas (path e op são livres)
 * @returns Task atualizada
 * 
 * @example
 * // Atualizar status
 * PatchTask("123", [{ op: "replace", path: "/status", value: "completed" }])
 * 
 * // Atualizar descrição
 * PatchTask("123", [{ op: "replace", path: "/description", value: "Nova descrição" }])
 * 
 * // Atualizar múltiplos campos
 * PatchTask("123", [
 *   { op: "replace", path: "/status", value: "in-progress" },
 *   { op: "replace", path: "/priority", value: "high" },
 * ])
 */
export async function PatchTask(taskId: string, operations: IPatchOperation[]): Promise<Task | any> {
  const url = `${endpoints.WORKFLOWFHIR}/Task/${taskId}`;
  
  const data = auxiliarData.Patch({
    operations,
  });

  const headers = {
    Accept: "application/json-patch+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/json-patch+json",
  };

  const response = await useAxios
    .patch(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`PatchTask: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("PatchTask ", error);
      // toast.error(`PatchTask Error: ${error?.response?.status}`);
      throw new Error();
    });
    
  if (response) return response;
}